import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Wrapper,
  FloatingLabel,
  ContentWrapper,
  Underline,
  ChipInputField,
} from '@layout/CustomFormFields';
import { Chip } from '@atoms';

class ChipsInput extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    floatingLabelText: PropTypes.node.isRequired,
    chips: PropTypes.arrayOf(PropTypes.string).isRequired,
    addChip: PropTypes.func.isRequired,
    deleteChip: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  };

  state = {
    focused: false,
    input: '',
  };

  get safeProps() {
    const { id, ...rest } = this.props;
    return rest;
  }

  setFocus = () => {
    document.getElementById(`${this.props.id}-input`).focus();
  };

  changeInput = ({ target: { value: input } }) => {
    this.setState({ input });
  };

  handleInput = ({ keyCode }) => {
    const { addChip, deleteChip, chips } = this.props;
    const { input } = this.state;
    if ([13, 32].includes(keyCode)) {
      addChip(input);
      this.setState({ input: '' });
    }
    if (keyCode === 8 && chips.length && !input) {
      const lastChip = chips[chips.length - 1];
      deleteChip(lastChip);
    }
  };

  onFocus = () => {
    this.setState({ focused: true });
  };

  onBlur = () => {
    this.setState({ focused: false });
    this.handleInput({ keyCode: 13 });
  };

  renderChip = (chip, key) => (
    <Chip key={key} {...this.safeProps}>
      {chip}{' '}
      <span onClick={() => this.props.deleteChip(chip)} className="delete-chip">
        ×
      </span>
    </Chip>
  );

  render() {
    const { id, floatingLabelText, chips = [], disabled } = this.props;
    const { input, focused } = this.state;
    return (
      <Wrapper id={id} {...this.safeProps} onClick={this.setFocus}>
        <FloatingLabel
          htmlFor={`${id}-input`}
          shouldShrink={input || focused || chips.length}
          focused={focused}
        >
          {floatingLabelText}
        </FloatingLabel>
        <ContentWrapper {...this.safeProps}>
          {chips.map(this.renderChip)}
          <ChipInputField
            {...this.safeProps}
            id={`${id}-input`}
            type="text"
            value={input}
            shouldShrink={chips.length && !focused}
            onChange={this.changeInput}
            onKeyDown={this.handleInput}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            disabled={disabled}
          />
        </ContentWrapper>
        <div>
          <Underline {...this.safeProps} />
        </div>
      </Wrapper>
    );
  }
}

export default ChipsInput;



// WEBPACK FOOTER //
// ./components/molecules/ChipsInput.js